import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ModelListComponent } from './product/modellist/modellist.component';
import { ModelDetailComponent } from './product/model-detail/model-detail.component';
import { ModelDetailFormComponent } from './product/model-detail-form/model-detail-form.component';
import { LoginComponent } from './auth/login/login.component';
import { RegisterComponent } from './auth/register/register.component';
import { ClientDetailFormComponent } from './client/client-detail-form/client-detail-form.component';
import { authGuard, redirectIfAuthenticatedGuard, verifiedEmailGuard, redirectIfVerifiedGuard } from './auth/auth.guard';
import { ContentManagerComponent } from './media/content-manager/content-manager.component';
import { CommunityGuidelinesComponent } from './community-guidelines/community-guidelines.component';
import { VerifyEmailComponent } from './auth/email-verification/verify-email.component';
import { MyLikesComponent } from './likes/pages/my-likes/my-likes.component';

const routes: Routes = [
  {path:'', loadComponent: () => import('./landing-page/landing-page.component').then(m => m.LandingPageComponent)},
  {path:'models', component: ModelListComponent},
  {path:'models/join', loadComponent: () => import('./product/model-landing/model-landing.component').then(m => m.ModelLandingComponent)},
  {path:'models/join/:ref', loadComponent: () => import('./product/model-landing/model-landing.component').then(m => m.ModelLandingComponent)},
  {path:'models/:id', component: ModelDetailComponent, canActivate: [authGuard]},
  {path:'models/:id/edit', component: ModelDetailFormComponent, canActivate: [authGuard]},
  {path:'clients/:id/edit', component: ClientDetailFormComponent, canActivate: [authGuard]},
  {path:'login', component: LoginComponent, canActivate: [redirectIfAuthenticatedGuard]},
  {path:'register', component: RegisterComponent, canActivate: [redirectIfAuthenticatedGuard]},
  {path:'register/:ref', component: RegisterComponent, canActivate: [redirectIfAuthenticatedGuard]},
  {path:'content-manager', component: ContentManagerComponent, canActivate: [authGuard, verifiedEmailGuard]},
  {path:'verify-email', component: VerifyEmailComponent, canActivate: [authGuard, redirectIfVerifiedGuard]},
  {path:'my-likes', component: MyLikesComponent, canActivate: [authGuard]},
  {path:'community-guidelines', component: CommunityGuidelinesComponent}
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
